import { getAuthenticated } from '../../../../../services/RestTemplate';
import { objToUrlParams } from '../../../../../shared/helpers/url-params.helper';

const eventsApi = '/events';

export function getEvents(args) {
    const urlParams = objToUrlParams(args);
    const getEventsUrl = eventsApi + urlParams;

    return getAuthenticated(getEventsUrl);
}
